export default __webpack_public_path__ + "static/video-banner-2c046e59c686e62dd478fad2fcb9b931.mp4";